import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useConsentReady } from "@/contexts/CookieConsentContext";

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: (...args: unknown[]) => void;
  }
}

const PIXEL_ID = "1657438068870809";

export function MetaPixel() {
  const isMarketingAllowed = useConsentReady("marketing");
  const injectedRef = useRef(false);
  const location = useLocation();

  // Inject pixel script once when marketing consent is granted
  useEffect(() => {
    if (!isMarketingAllowed || injectedRef.current) return;
    injectedRef.current = true;

    /* eslint-disable */
    const n: any = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    /* eslint-enable */

    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);

    window.fbq("init", PIXEL_ID);
    window.fbq("track", "PageView");

    // Add noscript fallback
    const noscript = document.createElement("noscript");
    const img = document.createElement("img");
    img.height = 1;
    img.width = 1;
    img.style.display = "none";
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, [isMarketingAllowed]);

  // Track route changes as PageView events
  useEffect(() => {
    if (!isMarketingAllowed || !injectedRef.current) return;
    window.fbq("track", "PageView");
  }, [location.pathname, isMarketingAllowed]);

  return null;
}
